import { COLLECTIONS } from "constants/action-types";

export interface ISyncInventoryUnitsPayload {
    collectionId: string;
    itemIds: string[];
    warehouseId: string;
    merchantId: string;
}

export const fetchProducts = (id: string, brandId: string) => {
    return {
        payload: {
            id,
            brandId,
        },
        type: COLLECTIONS.COLLECTION.PRODUCT.FETCH.START,
    };
};

export const syncInventoryUnitsStart = (payload: ISyncInventoryUnitsPayload) => ({
    type: COLLECTIONS.COLLECTION.PRODUCT.INVENTORY.SYNC_UNITS.START,
    payload,
});

export const syncInventoryUnitsStop = () => ({
    type: COLLECTIONS.COLLECTION.PRODUCT.INVENTORY.SYNC_UNITS.STOP,
});
